import * as Helper from "./../../_Helper";
const controller = "/terminals/mobile/";

function getUrl(uid) {
  return `${controller}${uid?.toString()}/settings`;
}

function getPhotoOptionsUrl(uid) {
  return `${controller}${uid?.toString()}/photooptions`;
}

function getDarkModeUrl(uid, isDark) {
  return `${controller}${uid?.toString()}/setdarkmode/${isDark}`;
}

function getWithoutCardUrl(uid, state) {
  return `${controller}${uid?.toString()}/setwithoutcard/${state}`;
}

function getSoundUrl(uid, state) {
  return `${controller}${uid?.toString()}/setsound/${state}`;
}

function getPhotoCaptureUrl(uid, state) {
  return `${controller}${uid?.toString()}/photocapture/${state}`;
}

function getLogUrl(uid) {
  return `${controller}${uid?.toString()}/log`;
}

export function getData(http, uid) {
  console.log(getUrl(uid));

  return http.get(getUrl(uid), Helper.getAuthConfig(uid));
}

export function setDarkMode(http, uid, isDark) {
  //url, body, headers - tady je body pro post null protoze je to v url
  return http.post(getDarkModeUrl(uid, isDark), null, Helper.getAuthConfig(uid));
}

export function setSoundEnabled(http, uid, state) {
  //url, body, headers - tady je body pro post null protoze je to v url
  return http.post(getSoundUrl(uid, state), null, Helper.getAuthConfig(uid));
}

export function setPhotoCaptureTest(http, uid, state) {
  //url, body, headers - tady je body pro post null protoze je to v url
  return http.post(getPhotoCaptureUrl(uid, state), null, Helper.getAuthConfig(uid));
}

export function setWithoutCard(http, uid, state) {
  //url, body, headers - tady je body pro post null protoze je to v url
  return http.post(getWithoutCardUrl(uid, state), null, Helper.getAuthConfig(uid));
}

export function addLog(http, uid, data) {
  //url, body, headers
  const body = { data: data };
  return http.post(getLogUrl(uid), body, Helper.getAuthConfig(uid));
}

export function setPhotoOption(http, uid, data) {
  //url, body, headers
  return http.post(getPhotoOptionsUrl(uid), data, Helper.getAuthConfig(uid));
}
